var map = {
	"./logo.svg": "9b19",
	"./logo/csc_05.png": "f2be",
	"./logo/logo_2021_554d3ee.png": "05d9",
	"./logo/toplogo.png": "d7bf",
	"./logo/下载 (1).png": "c0d7",
	"./logo/下载.png": "ef33",
	"./logo/图片 1.png": "483e",
	"./logo/图片 11.png": "dabc",
	"./logo/图片 51.png": "e723"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a3d4";